import React, { Component } from 'react';
import axios from 'axios';
import { translate } from 'react-i18next';
import * as $ from 'jquery';

let cancelToken;
let state;
let tokenSession;

class FacturasContainer extends Component {

    getInitState = () => {
        return {
            rfc: "",
            razon_social: "",
            numero_interior: "",
            numero_exterior: "",
            codigo_postal: "",
            colonia: "",
            municipio: "",
            calle: "",
            estado: "",
            isEditing: false,
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getFacturas({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });

    }

    getFacturas = (params) => {
        this.props.post(
            "/getFacturas",
            params,
            (response) => this.didGetFacturas(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetFacturas = (response) => {
        this.setState({
            rfc: response.rfc,
            razon_social: response.razon_social,
            numero_interior: response.numero_interior,
            numero_exterior: response.numero_exterior,
            codigo_postal: response.codigo_postal,
            colonia: response.colonia,
            municipio: response.municipio,
            calle: response.calle,
            estado: response.estado,
        })
    }

    handleChangeRfc = (event) => {
        this.setState({ rfc: event.target.value })
    }

    handleRazonSocial = (event) => {
        this.setState({ razon_social: event.target.value })
    }

    handleNumeroInterior = (event) => {
        this.setState({ numero_interior: event.target.value })
    }

    handleNumeroExterior = (event) => {
        this.setState({ numero_exterior: event.target.value })
    }

    handleCodigoPostal = (event) => {
        this.setState({ codigo_postal: event.target.value })
    }

    handleColonia = (event) => {
        this.setState({ colonia: event.target.value })
    }

    handleMunucipio = (event) => {
        this.setState({ municipio: event.target.value })
    }

    handleCalle = (event) => {
        this.setState({ calle: event.target.value })
    }

    handleEstado = (event) => {
        this.setState({ estado: event.target.value })
    }

    handleEditClick = () => {
        this.setState({ isEditing: true });
    }

    handleErrorResponse = (error) => {
        alert(error.message)
    }

    didSumitInvoicing = (response) => {
        alert(response.msg);
        this.reload();
    }

    handleSummitInvoicing = (event) => {
        event.preventDefault();
        this.props.post("/editFacturas", Object.assign({},
            { token_id: this.props.getTokenId() },
            { token_session: this.props.getTokenSession() },
            { rfc: this.state.rfc },
            { razon_social: this.state.razon_social },
            { calle: this.state.calle },
            { numero_exterior: this.state.numero_exterior },
            { numero_interior: this.state.numero_interior },
            { codigo_postal: this.state.codigo_postal },
            { colonia: this.state.colonia },
            { municipio: this.state.municipio },
            { estado: this.state.estado }
        ), (response) => this.didSumitInvoicing(response), (error) => this.handleErrorResponse(error), cancelToken);
    }

    render() {
        const isEditing = this.state.isEditing;
        const { t } = this.props;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex' }}>
                            <div style={{ width: "100%" }}>
                                <h4 className="panel-title">{t('dashboard.profile.invoicing.heading')}</h4>
                            </div>
                        </div>
                        <div className="panel-body">
                            <form method="post" onSubmit={this.handleSummitInvoicing} >
                                <fieldset>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.rfc')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.rfc')}
                                                type="text"
                                                onChange={this.handleChangeRfc}
                                                value={this.state.rfc} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.r_z')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.r_z')}
                                                type="text"
                                                onChange={this.handleRazonSocial}
                                                value={this.state.razon_social} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.holder_street')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.holder_street')}
                                                type="text"
                                                onChange={this.handleCalle}
                                                value={this.state.calle} />
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.number_e')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.number_e')}
                                                type="text"
                                                onChange={this.handleNumeroExterior}
                                                value={this.state.numero_exterior} />
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.number_i')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.number_i')}
                                                type="text"
                                                onChange={this.handleNumeroInterior}
                                                value={this.state.numero_interior} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.holder_po')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.holder_po')}
                                                type="text"
                                                onChange={this.handleCodigoPostal}
                                                value={this.state.codigo_postal} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.holder_neighborhood')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.holder_neighborhood')}
                                                type="text"
                                                onChange={this.handleColonia}
                                                value={this.state.colonia} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.holder_city')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.holder_city')}
                                                type="text"
                                                onChange={this.handleMunucipio}
                                                value={this.state.municipio} />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="interests">
                                                {t('dashboard.profile.invoicing.holder_state')}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder={t('dashboard.profile.invoicing.holder_state')} type="text"
                                                onChange={this.handleEstado}
                                                value={this.state.estado} />
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-primary btn-singup"
                                        type="submit">
                                        {t('dashboard.profile.btn_save')}
                                    </button>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default translate('common')(FacturasContainer);


// WEBPACK FOOTER //
// ./src/dashboard/profile/FacturasContainer.js